<template>
    <div>
        <section class="section home home-subscribe bg-dark" id="home">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2 text-center">
                        <div class="home-wrapper">
                            <div class="text-tran-box text-tran-box-dark">
                                <h1 class="text-transparent">{{$t('Home.welcome.title')}}</h1>
                            </div>
                            <h3 class="black-background">{{$t('Home.welcome.description')}}</h3>
                        </div> <!-- end home wrapper -->
                        <br>
                        <h4 class="black-background">{{$t('Home.welcome.join')}}</h4>
                        <div class="text-center subscribe-form">
                            <form action="#" onSubmit="return false" novalidate>
                                <input type="text" v-validate="'email'" v-model="user.email" placeholder="Email" name="email">
                                <button  v-bind:class=" errors.has('email') || user.email === '' ? 'email-error' : 'email-success' " v-on:click="sendMail" :disabled="loading || errors.has('email') || user.email === ''" >GO</button>
                            </form>
                        </div>
                    </div> <!-- end col -->
                </div> <!-- end row -->
            </div> <!-- end container -->
        </section>
        <section>
            <div class="container">
                <div class="row">                  
                    <div class="col-lg-8 offset-lg-2">                       
                        <!--  <div class="facts-box testimonial-cta">
                            <div class="row">
                              <a href="https://www.survio.com/survey/d/F3G6M6S4N6C4S2I5X" target="_blank" style="display:flex;
                              text-decoration:none;
                              background-color:#000000;
                              color:#ffffff;
                              font-family:Arial, Helvetica, sans-serif;
                              -webkit-border-radius:4px;
                              -moz-border-radius:4px;
                              border-radius:4px;
                              padding:11px 25px;font-size:16px;
                              line-height:180%;
                              font-weight: bold;
                              letter-spacing: 0.5px">Aidez-nous à vous aider !</a>
                                <div class="col-sm-12">                               
                                
                                   <img src="static/images/testi-1.jpg" alt="img" class="rounded-circle img-thumbnail">
                                   <p>" Concept génial qui pourrait changer notre quotidien à confirmer si la communauté suit ! " - <span class="text-colored">François.S</span></p>
                                
                                </div>
                            </div>
                        </div>                        
                    </div>  -->
                </div>
            </div>
        </section>
        <div class="clearfix"></div>
        <h2 style="text-align:center;">{{$t('Home.parking-facts.title')}}</h2>
        <section class="section" id="features">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <div class="features-box text-center">
                            <div class="feature-icon">
                                <i class="fas fa-car"></i>
                            </div>
                            <h3>30%</h3>
                            <p class="text-muted">{{$t('Home.parking-facts.30%')}}</p>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="features-box text-center">
                            <div class="feature-icon">
                                <i class="far fa-tired"></i>
                            </div>
                            <h3>10h</h3>
                            <p class="text-muted">{{$t('Home.parking-facts.10h')}}</p>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="features-box text-center">
                            <div class="feature-icon">
                                <i class="fas fa-euro-sign"></i>
                            </div>
                            <h3>15€</h3>
                            <p class="text-muted">{{$t('Home.parking-facts.15€')}}</p>
                        </div>
                    </div>
                    <div class="col-sm-3">
                        <div class="features-box text-center">
                            <div class="feature-icon">
                                <i class="fas fa-skull-crossbones"></i>
                            </div>
                            <h3>18kg</h3>
                            <p class="text-muted">{{$t('Home.parking-facts.18kg')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-sm-12 offset-sm-1 text-center" >
                        <img src="static/images/masquotte.png" class="img-fluid ">
                    </div>
                </div>
            </div>
        </section>
                       <!--
        <section class="section bg-white padding-b-0" id="pricing">
            <div class="container">

                <div class="row">
                    <div class="col-sm-12 text-center">
                        <h2 class="title">Simple Pricing</h2>
                        <p class="title-alt">Looks beautiful & ultra-sharp on Retina Screen Displays. Retina Icons, Fonts & all <br/> others graphics are optimized.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 offset-lg-1">
                        <div class="row">
                            --><!--Pricing Column--><!--
                            <article class="pricing-column col-lg-4">
                                <div class="inner-box">
                                    <div class="plan-header text-center">
                                        <h3 class="plan-title">Basic</h3>
                                        <h2 class="plan-price">$19</h2>
                                        <div class="plan-duration">Per Month</div>
                                    </div>
                                    <ul class="plan-stats list-unstyled">
                                        <li> <i class="pe-7s-server"></i>10 GB Storege</li>
                                        <li> <i class="pe-7s-graph"></i>500 GB Bandwidth</li>
                                        <li> <i class="pe-7s-mail-open"></i>Email Support</li>
                                        <li> <i class="pe-7s-tools"></i>24x7 Support</li>
                                    </ul>

                                    <div class="text-center">
                                        <a href="#" class="btn btn-sm btn-dark">Signup Now</a>
                                    </div>
                                </div>
                            </article>
                            --><!--Pricing Column--><!--
                            <article class="pricing-column col-lg-4">
                                <div class="inner-box active">
                                    <div class="plan-header text-center">
                                        <h3 class="plan-title">Premium</h3>
                                        <h2 class="plan-price">$29</h2>
                                        <div class="plan-duration">Per Month</div>
                                    </div>
                                    <ul class="plan-stats list-unstyled">
                                        <li> <i class="pe-7s-server"></i>10 GB Storege</li>
                                        <li> <i class="pe-7s-graph"></i>500 GB Bandwidth</li>
                                        <li> <i class="pe-7s-mail-open"></i>Email Support</li>
                                        <li> <i class="pe-7s-tools"></i>24x7 Support</li>
                                    </ul>
                                    <div class="text-center">
                                        <a href="#" class="btn btn-sm btn-custom">Signup Now</a>
                                    </div>
                                </div>
                            </article>
                            --><!--Pricing Column--><!--
                            <article class="pricing-column col-lg-4">
                                <div class="inner-box">
                                    <div class="plan-header text-center">
                                        <h3 class="plan-title">Developer</h3>
                                        <h2 class="plan-price">$39</h2>
                                        <div class="plan-duration">Per Month</div>
                                    </div>
                                    <ul class="plan-stats list-unstyled">
                                        <li> <i class="pe-7s-server"></i>10 GB Storege</li>
                                        <li> <i class="pe-7s-graph"></i>500 GB Bandwidth</li>
                                        <li> <i class="pe-7s-mail-open"></i>Email Support</li>
                                        <li> <i class="pe-7s-tools"></i>24x7 Support</li>
                                    </ul>

                                    <div class="text-center">
                                        <a href="#" class="btn btn-sm btn-dark">Signup Now</a>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>--><!-- end col --><!--
                </div>
            </div>
        </section>-->
       <!--
        <section class="section bg-white" id="clients">
            <div class="container">
                <div class="row text-center">
                    <div class="col-sm-12">
                        <h2 class="title">Trusted by Thousands</h2>
                        <p class="slogan">Lorem ipsum dolor sit amet, consectetur adipis.</p>
                        <ul class="list-inline client-list">
                            <li class="list-inline-item"><a href="" title="Microsoft"><img src="static/images/clients/microsoft.png" alt="clients"></a></li>
                            <li class="list-inline-item"><a href="" title="Google"><img src="static/images/clients/google.png" alt="clients"></a></li>
                            <li class="list-inline-item"><a href="" title="Instagram"><img src="static/images/clients/instagram.png" alt="clients"></a></li>
                            <li class="list-inline-item"><a href="" title="Converse"><img src="static/images/clients/converse.png" alt="clients"></a></li>
                        </ul>
                    </div> --><!-- end Col --><!--
                </div>
            </div>
        </section>
        <section class="section" id="faqs">
            <div class="container">
                <div class="row text-center">
                    <div class="col-sm-12">
                        <h2 class="title">FAQ</h2>
                        <p class="title-alt">Looks beautiful &amp; ultra-sharp on Retina Screen Displays. Retina Icons, Fonts &amp; all <br> others graphics are optimized.</p>
                        <div class="row text-left">
                            <div class="col-sm-6">
                                <div class="question-box">
                                    <h4><span class="text-colored">Q.</span>What is Lorem Ipsum?</h4>
                                    <p><span><b>A. </b></span>Lorem ipsum dolor sit amet, in mea nonumes dissentias dissentiunt, pro te solet iriure. Cu sit consetetur moderatius intellegam, ius decore accusamus te. Ne primis suavitate disputando nam. Mutat convenirete.</p>
                                </div>

                                <div class="question-box">
                                    <h4><span class="text-colored">Q.</span>How many variations exist?</h4>
                                    <p><span><b>A. </b></span>Lorem ipsum dolor sit amet, in mea nonumes dissentias dissentiunt, pro te solet iriure. Cu sit consetetur moderatius intellegam, ius decore accusamus te. Ne primis suavitate disputando nam. Mutat convenirete.</p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="question-box">
                                    <h4><span class="text-colored">Q.</span>Is safe use Lorem Ipsum?</h4>
                                    <p><span><b>A. </b></span>Lorem ipsum dolor sit amet, in mea nonumes dissentias dissentiunt, pro te solet iriure. Cu sit consetetur moderatius intellegam, ius decore accusamus te. Ne primis suavitate disputando nam. Mutat convenirete.</p>
                                </div>

                                <div class="question-box">
                                    <h4><span class="text-colored">Q.</span>License & Copyright</h4>
                                    <p><span><b>A. </b></span>Lorem ipsum dolor sit amet, in mea nonumes dissentias dissentiunt, pro te solet iriure. Cu sit consetetur moderatius intellegam, ius decore accusamus te. Ne primis suavitate disputando nam. Mutat convenirete.</p>
                                </div>
                            </div>
                        </div>
                    </div> --><!-- end Col -->
                    <!--
                </div>

            </div>
        </section>-->
    </div>
</template>
<script>
import quizzes from './resources/quizz.json'
export default {
  name: 'coming',
  data () {
    return {
      selected: '',
      quizes: quizzes,
      user: {full_name: '', email: '', age: '', job: '', gender: '', q_id: '', from: 'Newsletter'},
      loading: false,
      toast_options: {position: 'bottom-right', duration: 5000, theme: 'primary', type: 'success', action: {text: 'FERMER', onClick: (e, toastObject) => { toastObject.goAway(0) }}}
    }
  },
  mounted () { /*
    this.$contact = this.$resource('messages', {from: 'Chaperon Contact<no-reply@chaperon.me>', to: 'wachiepo@gmail.com', subject: 'New Contact', text: 'Wecome punk', multipart: true}, {}, {
      before: () => { this.loading = true },
      after: () => { this.loading = false }
    })
    */
    this.resource = this.$resource('mailer')
  },
  methods: {
    sendMail: function () {
        this.loading = true
        const data = {
            EMAIL: this.user.email
        }
        $.ajax({
            url: 'https://foxypark.us20.list-manage.com/subscribe/post-json?u=1482774125b03900f5f35e0ca&id=44036464d0&c=?',
            type: 'GET',
            data: data,
            dataType: 'jsonp',
            contentType: "application/json; charset=utf-8",
            success: data => {
                if (data['result'] != "success") {
                    this.$toasted.show(data['msg'], this.toast_options)
                } else {
                    this.$toasted.show('Merci  pour votre participation ! <3', this.toast_options)
                }
                this.user.email = ''
                this.loading = false
            }   
        });
    },
    goToQuizz: function (selected) {
      if (selected !== '') {
        this.$router.push({path: '/quizz/' + selected})
      }
    }
  }
}
</script>
<style>
.section-quizz .row .col-sm-6{
    padding-bottom: 12px;
}
</style>




// WEBPACK FOOTER //
// Home.vue?2217b32c